import React, { useEffect, useMemo, useState, useRef } from "react";
import PageHeader from "../../components/PageHeader/PageHeader";
import { useNavigate, useLocation } from "react-router-dom";
import CommonTable from "../../components/CommonTable/CommonTable";
import { FaEye, FaTimes } from "react-icons/fa";
import { URLS } from "../../Services/Constant";
import { get } from "../../Services/ApiHandler";
import "./NotificationAdd.css";
import moment from "moment";
import usePermission from "../../customHook/usePermission";

const Notification = () => {
  const location = useLocation();
  const [page, setPage] = useState(location?.state?.page || 1);
  const [searchText, setSearchText] = useState("");
  const [data, setData] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [pagination, setPagination] = useState(null);
  const navigate = useNavigate();
  const permission = usePermission();

  const pageRef = useRef(page);

  // keep pageRef in sync with the latest page
  useEffect(() => {
    pageRef.current = page;
  }, [page]);

  // clear state after using it (run only once when component mounts)
  useEffect(() => {
    if (location?.state?.page) {
      navigate(location.pathname, { replace: true, state: {} });
    }
  }, []);

  const handleView = (row) => {
    if (!row) return;
    console.log("SDSADL", row);
    navigate("/notification-add", {
      state: { data: row, mode: "view", page: pageRef.current },
    });
  };

  const columns = useMemo(() => {
    let d = [
      {
        Header: "S.No",
        accessor: "sno",
        disableSortBy: true,
        width: "1%",
        Cell: ({ row }) => {
          return (
            <span className="sno">
              {String((row?.index || 0) + 1 + (page - 1) * 10).padStart(2, "0")}
            </span>
          );
        },
      },
      {
        Header: "User",
        accessor: "user_name",
        width: "20%",
        Cell: ({ value, row }) => {
          const { user_name, is_all_users } = row.original;
          console.log("ASDASasas", value, row);

          return (
            <p className="mb-0">
              {is_all_users ? "All Users" : "Specific" || "N/A"}
            </p>
          );
        },
      },
      {
        Header: "Notifications",
        accessor: "description",
        width: "50%",
        Cell: ({ row }) => {
          const { title, description } = row.original;
          return (
            <div className="mb-0">
              {title && (
                <h6
                  style={{
                    fontWeight: "600",
                    marginBottom: "2px",
                    fontSize: "14px",
                  }}
                >
                  {title}
                </h6>
              )}
              <p
                className="mb-0"
                style={{
                  fontSize: "13px",
                  color: title ? "#666" : "inherit",
                }}
              >
                {description || "N/A"}
              </p>
            </div>
          );
        },
      },
      {
        Header: "Date & Time",
        accessor: "created_at",
        width: "15%",
        Cell: ({ value }) => {
          return (
            <p className="mb-0">
              {value ? moment(value).format("DD-MM-YYYY hh:mm:ss A") : "N/A"}
            </p>
          );
        },
      },
    ];

    let action = {
      Header: "Action",
      accessor: "action",
      disableSortBy: true,
      width: "20%",
      Cell: ({ row }) => {
        return (
          <>
            {permission?.includes("CAN-VIEW-PUSH_NOTIFICATION") && (
              <button
                className="action-btn"
                onClick={() => handleView(row?.original)}
              >
                <FaEye />
              </button>
            )}
          </>
        );
      },
    };

    return [...d, action];
  }, [page, data]);

  const handleClearSearch = () => {
    setSearchText("");
    setPage(1);
  };

  const fetchNotification = async () => {
    try {
      let res = await get(
        `${URLS.NOTIFICATION_LIST}?page=${page || 1}&search=${searchText || ""}`
      );
      console.log("Notification list res:", res);

      if (res?.status === "success") {
        setData(res?.data || []);
        setTotalCount(res?.count || 0);
        setPagination({
          current_page: res?.current_page || 1,
          last_page: res?.total_pages || 1,
        });
      }
    } catch (error) {
      console.error("Error fetching notifications:", error);
    }
  };

  useEffect(() => {
    fetchNotification();
  }, [page, searchText]);

  return (
    <>
      <PageHeader
        title="Push Notifications"
        buttonText="+Add Push Notifications"
        buttonPath="/notification-add"
        permissionAllowed={"CAN-ADD-PUSH_NOTIFICATION"}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "20px",
        }}
      >
        <h2 style={{ fontSize: "20px", fontWeight: "600", color: "#7a52ab" }}>
          Total: {totalCount || 0}
        </h2>
        <div className="search-wrapper">
          <input
            type="text"
            placeholder="Search description"
            className="search-input"
            value={searchText || ""}
            onChange={(e) => {
              setSearchText(e.target.value);
              setPage(1);
            }}
          />
          {searchText && (
            <FaTimes
              className="search-clear-icon"
              onClick={handleClearSearch}
            />
          )}
        </div>
      </div>
      <CommonTable
        columns={columns}
        data={data || []}
        pagecount={pagination}
        setPageno={setPage}
        pageno={page || 1}
      />
    </>
  );
};

export default Notification;
